const listComponents = (name, instance) => {
  const comname = name.toUpperCase();
  const set = WebComponent.coms[comname] ? WebComponent.coms[comname] : (WebComponent.coms[comname] = []);
  set.push(instance);
};

function WebComponent(name, params) {
  const { props, methods, init, connected } = params;

  class Com extends HTMLElement {
    constructor() {
      super();

      const $context = (this.$context = {
        $el: this,
        init,
        connected,
        ...methods,
      });

      $context?.init?.();

      // list web component
      listComponents(name, this);
    }

    connectedCallback() {
      this.$context?.connected?.();
    }

    static get observedAttributes() {
      return props || [];
    }

    attributeChangedCallback(name, oldValue, newValue) {
      const names = name.split('-').map((name) => {
        const [fl, ...rest] = name;
        return `${fl.toUpperCase()}${rest.join('')}`;
      });

      const methodName = `on${names.join('')}`;

      // check and execute if callback exist
      const $context = this.$context;
      $context?.[methodName]?.(oldValue, newValue);
    }
  }

  customElements.define(name, Com);
  return Com;
}

// to maintain list of web component
WebComponent.coms = {};

// expose to global
window.WebComponent = WebComponent;
